import * as React from "react";
import { Button, Card, CardActions, CardContent, FormControl, FormGroup, Grid, InputLabel, MenuItem, Paper, Select, Snackbar, SnackbarContent, TextField } from "@material-ui/core";
import ChevronRightIcon from "@material-ui/icons/ChevronRight";
import { Footer, Header, Navigation } from "src/component/shared";
import { AdministrationMenu } from "../shared/menu/AdministrationMenu";
import { UnidentifiedProductsGrid } from "./UnidentifiedProductsGrid";

import "./UnidentifiedProductsList.scss";
import Rest from "src/services/Rest";
import BlacklistModal from "./BlacklistModal";
import UnidentifiedProductsModal from "./UnidentifiedProductsModal";
import { CurrentDate, SomeDaysAgo } from "src/services/DateService";
import { Redirect } from "react-router-dom";

const finalDate = CurrentDate();
const initDate = SomeDaysAgo(32);

const styles = {
  textField: {
    marginLeft: 5,
    marginRight: 5,
  },
};

// tslint:disable-next-line:no-empty-interface
export interface IProductGridProps { }

// tslint:disable-next-line:no-empty-interface
export interface IProductGridState {
  additionalCnpjs: any[];

  alert: {
    message: any,
    open: boolean,
    type: any,
  },

  blacklistData: any[];
  alertMessage: string;
  alertOpened: boolean;
  alertType: string;

  error: string | null;
  loading: boolean;
  loadingProduto: boolean;
  produto: {};
  redirectToImportPni: boolean;
  rows?: any[];
  showBlacklistModal: boolean,

  showModal: boolean;
  totalItems: number;
  viewProduto?: string;

  search: {
    cnpjs: string;
    dat_fim: string;
    dat_inicio: string;
    descricao: string;
    isbn: string;
    page: number;
    size: number;
    sku: string;
  };
}

// tslint:disable-next-line:object-literal-sort-keys
export class UnidentifiedProductsList extends React.Component<
  IProductGridProps,
  IProductGridState
> {
  constructor(props: IProductGridProps) {
    super(props);

    this.state = {
      additionalCnpjs: [],

      alert: {
        message: "",
        open: false,
        type: "",
      },

      alertMessage: "",
      alertOpened: false,
      alertType: "success",
      blacklistData: [],

      error: null,
      loading: false,
      loadingProduto: false,
      produto: {},
      redirectToImportPni: false,
      rows: [],
      showBlacklistModal: false,

      showModal: false,
      totalItems: 0,
      viewProduto: undefined,

      search: {
        cnpjs: "",
        dat_fim: finalDate,
        dat_inicio: initDate,
        descricao: "",
        isbn: "",
        page: 0,
        size: 10,
        sku: "",
      },
    };

    this.search = this.search.bind(this);
    this.viewProduct = this.viewProduct.bind(this);
    this.handleChangePage = this.handleChangePage.bind(this);
    this.textFieldStyle = this.textFieldStyle.bind(this);
    this.clear = this.clear.bind(this);
    this.openModal = this.openModal.bind(this);
  }

  public render() {
    const { search } = this.state;
    const { page, size } = search;

    if (this.state.redirectToImportPni) {
      return <Redirect to="/administration/product-import-pni" />;
    }

    return (
      <div>

        {this.state.showModal && (
          <UnidentifiedProductsModal
            open={true}
            handleClose={() => this.setState({ showModal: false })}
            title="Outros CNPJs"
            content={
              <>
                <div style={{ padding: 20 }}>
                  <ul>
                    {this.state.additionalCnpjs.map((cnpj, index) => (
                      <li className="cnpj-list" key={index}>{cnpj}</li>
                    ))}
                  </ul>
                </div>
              </>
            }
            onClose={() => this.setState({ showModal: false })}
          />
        )}

        {this.state.showBlacklistModal && (
          <BlacklistModal
            open={true}
            handleClose={() => this.setState({ showBlacklistModal: false })}
            title="Produtos na Lista Negra"
            onClose={() => this.setState({ showBlacklistModal: false })}
          />
        )}

        <Header
          title={"Produtos Não Identificados"}
          name={"Administrativo"}
          link={"/dashboard"}
        />
        <Navigation
          name={"Produtos Não Identificados"}
          linkDefault={"/administration/unidentified-products-list"}
          link={"/dashboard"}
          linkTitle={"Produtos"}
          painel={3}
          icon={<ChevronRightIcon />}
        />

        <AdministrationMenu paramIcon={null} />
        <div className="wrapper">
          <Grid container={true} className="panel-grid" spacing={16}>
            <Grid item={true} xs={12}>
              <Paper className="analytical-panel">
                <Grid container={true} direction="column" spacing={16}>
                  <Grid item={true}>
                    <Card>
                      <CardContent>
                        <form>
                          <FormGroup className="search-bar-grid" row={true}>
                            <TextField
                              label="SKU"
                              value={this.state.search.sku}
                              onChange={(event) => this.handleInputChange("sku", event.target.value)}
                              style={this.textFieldStyle()}
                              type="text"
                              autoComplete="text"
                              margin="normal"
                              required={false}
                            />
                            <TextField
                              label="ISBN"
                              value={this.state.search.isbn}
                              onChange={(event) => this.handleInputChange("isbn", event.target.value)}
                              style={this.textFieldStyle()}
                              type="text"
                              autoComplete="text"
                              margin="normal"
                              required={false}

                            />
                            <TextField
                              label="Descrição"
                              value={this.state.search.descricao}
                              onChange={(event) => this.handleInputChange("descricao", event.target.value)}
                              style={this.textFieldStyle()}
                              type="text"
                              autoComplete="text"
                              margin="normal"
                              required={false}
                            />
                            <TextField
                              label="CNPJ"
                              value={this.state.search.cnpjs}
                              onChange={(event) => this.handleInputChange("cnpjs", event.target.value)}
                              style={this.textFieldStyle()}
                              type="text"
                              autoComplete="text"
                              margin="normal"
                              required={false}
                            />
                            <TextField
                              color="primary"
                              defaultValue={search.dat_inicio}
                              value={this.state.search.dat_inicio}
                              id="dat_inicio"
                              type="date"
                              required={true}
                              label="Data início"
                              style={this.textFieldStyle()}
                              onChange={(event) => this.handleInputChange("dat_inicio", event.target.value)}
                              margin="normal"
                              InputLabelProps={{
                                shrink: true,
                              }}
                            />
                            <TextField
                              color="primary"
                              defaultValue={this.state.search.dat_fim}
                              value={this.state.search.dat_fim}
                              id="dat_fim"
                              type="date"
                              required={true}
                              label="Data fim"
                              style={this.textFieldStyle()}
                              onChange={(event) => this.handleInputChange("dat_fim", event.target.value)}
                              margin="normal"
                              InputLabelProps={{
                                shrink: true,
                              }}
                            />
                            <FormControl
                              required={false}
                              margin="normal"
                              style={this.textFieldStyle()}
                            >
                              <InputLabel>Tamanho da pagina</InputLabel>
                              <Select
                                value={this.state.search.size}
                                onChange={this.handleChangeCadastro}
                                inputProps={{
                                  id: 'size',
                                  name: 'size',
                                }}
                              >
                                <MenuItem value={10}>10</MenuItem>
                                <MenuItem value={50}>50</MenuItem>
                                <MenuItem value={100}>100</MenuItem>
                              </Select>
                            </FormControl>
                          </FormGroup>
                        </form>
                      </CardContent>
                      <CardActions>
                        <Button
                          className="filter-dialog-clear"
                          onClick={this.clear}
                        >
                          Limpar
                        </Button>
                        <Button
                          className="filter-dialog-close"
                          color="primary"
                          onClick={() => this.search()}
                        >
                          Pesquisar
                        </Button>
                        <Button
                          className="filter-dialog-close"
                          color="primary"
                          style={{ marginLeft: 'auto', display: "none" }}
                          onClick={this.handleClick}
                          disabled={true}
                        >
                          Importar
                        </Button>
                        <Button
                          className="filter-dialog-close"
                          color="primary"
                          onClick={() => this.export()}
                          style={{ marginLeft: 'auto' }}
                        >
                          Exportar
                        </Button>
                        <Button
                          className="filter-dialog-close"
                          color="primary"
                          onClick={() => this.openBlacklistModal()}
                        >
                          Ver lista negra
                        </Button>
                      </CardActions>
                    </Card>

                    <Card>
                      <CardContent>
                        <Snackbar
                          anchorOrigin={{
                            horizontal: 'center',
                            vertical: 'center',
                          }}
                          open={this.state.alertOpened}
                          autoHideDuration={4000}
                          onClose={this.closeAlert}
                        >
                          <SnackbarContent
                            message={this.state.alertMessage}
                            style={styles[this.state.alert.type]}
                          />
                        </Snackbar>
                        <UnidentifiedProductsGrid
                          error={this.state.error}
                          loading={this.state.loading}
                          items={[
                            { header: "SKU", row: "sku" },
                            { header: "ISBN", row: "isbn" },
                            { header: "Descrição", row: "descricao" },
                            { header: "Quantidade de Cupons", row: "qtd_cupom" },
                            { header: "Valor Médio", row: "vlr_medio_formatado" },
                            { header: "CNPJs", row: "cnpjs" },
                            { header: "Data Última Sellout", row: "data_ultima_sellout" }
                          ]}
                          rows={this.state.rows}
                          onViewRow={this.viewProduct}
                          handleChangePage={this.handleChangePage}
                          dialogTitle="Enviar para lista negra"
                          dialogContent="Deseja realmente enviar este item para a lista negra?"
                          tooltipTitle="Enviar para lista negra"
                          tableProps={{
                            limit: size,
                            page,
                            total: this.state.totalItems,
                          }}
                        />
                      </CardContent>
                    </Card>
                  </Grid>
                </Grid>
              </Paper>
            </Grid>
          </Grid>
        </div>

        <div className="users-register-footer">
          <Footer />
        </div>
      </div>
    );
  }

  private search() {
    const { page, size, sku, cnpjs, descricao, isbn, dat_inicio, dat_fim } = this.state.search;
    this.setState({ loading: true });

    let endPoint = "";
    let queryParam = `?page=${page}&pageSize=${size}`;

    if (sku || isbn || cnpjs || descricao || dat_inicio || dat_fim) {
      endPoint = "unidentified-products/search-grid";
      queryParam += this.getParams(sku, isbn, cnpjs, descricao, dat_inicio, dat_fim);
    } else {
      endPoint = "unidentified-products/search-grid";
    }

    const finalUrl = `${endPoint}${queryParam}`;

    Rest.GET(finalUrl, null)
      .then((response) => response.json())
      .then((result: any) => {
        if (!!result) {
          if (result.error) {
            this.openErrorAlert(result);
            this.setState({ loading: false, rows: [] });
            return;
          }

          const filteredRows = result.products.map((row: any) => {
            row.vlr_medio_formatado = new Intl.NumberFormat('pt-BR', {
              currency: 'BRL',
              style: 'currency',
            }).format(row.vlr_medio);
            if (row.cnpjs && row.cnpjs.length > 1) {
              row.allCnpjs = row.cnpjs_nomes;
              row.cnpjs = (
                <div onClick={() => this.openModal(row.allCnpjs)}>
                  {row.cnpjs[0]} <span className="cursor">...</span>
                </div>
              );
            } else if (row.cnpjs && row.cnpjs.length === 1) {
              row.cnpjs = <div>{row.cnpjs[0]}</div>;
            }
            return row;
          });

          this.setState({
            loading: false,
            rows: filteredRows,
            totalItems: Number(result.total),
          });
        }
      });
  }

  private viewProduct = async (produto: any) => {
    try {
      const idUsuarioCriacao = 1;
      if (produto.sku && produto.isbn && produto.descricao && idUsuarioCriacao) {
        await this.addToBlacklist(produto.sku, produto.isbn, produto.descricao, idUsuarioCriacao);
      } else {
        console.error('Alguns dos valores estão faltando, não é possível adicionar à lista negra.');
      }
    } catch (error) {
      console.error('Erro ao visualizar produto:', error.message);
    }
  };

  private handleChangePage = async (ev: any, page: number) => {
    const search = this.state.search;
    search.page = page;
    await this.setSearch(search);
    this.search();
  };

  private setSearch = async (search: {
    cnpjs: string;
    dat_fim: string;
    dat_inicio: string;
    descricao: string;
    isbn: string;
    page: number;
    size: number;
    sku: string;
  }) => {
    this.setState({ search });
  };

  private textFieldStyle(): React.CSSProperties | undefined {
    return {
      marginLeft: 5,
      marginRight: 5,
    };
  }

  private async clear() {
    this.setState({
      search: {
        cnpjs: "",
        dat_fim: initDate,
        dat_inicio: finalDate,
        descricao: "",
        isbn: "",
        page: this.state.search.page,
        size: 10,
        sku: "",
      }
    });
  }

  private getParams = (sku: string, isbn: string, cnpjs: string, descricao: string, datInicio: string, datFim: string) => {
    let queryParam = "";

    if (!!sku) {
      queryParam += `&sku=${sku.trim()}`;
    }

    if (!!isbn) {
      queryParam += `&isbn=${isbn.trim()}`;
    }

    if (!!cnpjs) {
      queryParam += `&cnpjs=${cnpjs.trim()}`;
    }

    if (!!descricao) {
      queryParam += `&descricao=${descricao}`;
    }

    if (!!datInicio) {
      queryParam += `&dat_inicio=${datInicio}`;
    }

    if (!!datFim) {
      queryParam += `&dat_fim=${datFim}`;
    }
    return queryParam;
  };

  private openErrorAlert(err: any) {
    let message = "";
    !!err.message ? (message = err.message) : (message = err.error);
    this.setState({ alertMessage: message, alertOpened: true });
  }

  private openModal = (additionalCnpjs: string | string[]) => {
    const cnpjsArray = Array.isArray(additionalCnpjs) ? additionalCnpjs : [additionalCnpjs];
    this.setState({
      additionalCnpjs: cnpjsArray,
      showModal: true
    });
  };

  private addToBlacklist = async (sku: string, isbn: string, descricao: string, idUsuarioCriacao: number) => {
    try {
      await Rest.PostBody('unidentified-products/add-to-blacklist', {
        descricao,
        id_usuario_criacao: idUsuarioCriacao,
        isbn,
        sku,
      });

      await this.search();

    } catch (error) {
      console.error('Erro ao adicionar produto à lista negra:', error);
    }
  };

  private handleInputChange = (field: string, value: string) => {
    const updatedSearch = Object.assign({}, this.state.search, { [field]: value });
    this.setState({ search: updatedSearch });
  };

  private openBlacklistModal = () => {
    this.setState({ showBlacklistModal: true });
  };

  private handleChangeCadastro = async (event: React.ChangeEvent<{ name?: string; value: unknown }>) => {
    const { name, value } = event.target;
    if (name) {
      const updatedSearch = Object.assign({}, this.state.search, { [name]: value as string });
      await this.setSearch(updatedSearch);
    }
  };

  private handleClick = () => {
    this.setState({ redirectToImportPni: true });
  }

  private export = () => {
    const { search } = this.state;

    const requestBody = {
      cnpjs: search.cnpjs,
      dat_fim: search.dat_fim,
      dat_inicio: search.dat_inicio,
      descricao: search.descricao,
      isbn: search.isbn,
      sku: search.sku,
    };

    Rest.PostBody('exportacao-pni/export', requestBody)
      .then((response) => {
        if (response) {
          this.openAlert("O relatório está sendo preparado para download.", "success");
        } else {
          this.openAlert("Erro ao iniciar exportação:", "error");
        }
      })
      .catch((error) => {
        this.openAlert("Erro de comunicação", "error");
      });
  };

  private openAlert = (message: any, type: any) => {
    this.setState({
      alertMessage: message,
      alertOpened: true,
      alertType: type,
    });
  };

  private closeAlert = () => {
    this.setState({
      alertMessage: "",
      alertOpened: false,
      alertType: "",
    });
  };
}



// WEBPACK FOOTER //
// ./src/component/administration/unidentified-products-list/UnidentifiedProductsList.tsx